import type { FieldTimeRangeProps } from '@spa/features/Scheduling'
import type { Moment } from 'moment'
import moment from 'moment'

export const getTimeRangeMomentDate = ({
  startsAt,
  timeRange = ['', '']
}: {
  startsAt: string | Moment
  timeRange: FieldTimeRangeProps['values']
}) => {
  const [startTime, endTime] = timeRange
  // as startTime and endTime are strings
  // we need to convert them to numbers
  const [startHour, startMin] = startTime.split(':')
  const startHourNumber = Number(startHour)
  const startMinNumber = Number(startMin)
  const [endHour, endMin] = endTime.split(':')
  const endHourNumber = Number(endHour)
  const endMinNumber = Number(endMin)

  const momentStart = moment(startsAt)
    .clone()
    .hours(startHourNumber)
    .minutes(startMinNumber)

  const momentEnd = momentStart
    .clone()
    .add(endHourNumber < startHourNumber ? 1 : 0, 'days')
    .hours(endHourNumber)
    .minutes(endMinNumber)

  return { momentStart, momentEnd }
}
